<template>
  <DsShowcase title="ProgressBarPlay" description="Barra de progresso com cor do seller, altura customizável e exibição de valor.">
    <!-- PROP: progress -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">progress</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — porcentagem de 0 a 100. Padrão: <code>0</code></p>
      <div class="tw:max-w-lg tw:space-y-5">
        <div v-for="p in [0, 15, 35, 60, 85, 100]" :key="p" class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-8 tw:text-right tw:opacity-50">{{ p }}%</span>
          <ProgressBarPlay :progress="p" class="tw:flex-1" />
        </div>
      </div>
    </section>

    <!-- PROP: height -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">height</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — altura CSS da barra. Padrão: <code>'14px'</code></p>
      <div class="tw:max-w-lg tw:space-y-5">
        <div class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-10 tw:text-right tw:opacity-50">4px</span>
          <ProgressBarPlay :progress="70" height="4px" class="tw:flex-1" />
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-10 tw:text-right tw:opacity-50">8px</span>
          <ProgressBarPlay :progress="70" height="8px" class="tw:flex-1" />
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-10 tw:text-right tw:opacity-50">14px</span>
          <ProgressBarPlay :progress="70" height="14px" class="tw:flex-1" />
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-10 tw:text-right tw:opacity-50">24px</span>
          <ProgressBarPlay :progress="70" height="24px" class="tw:flex-1" />
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <span class="tw:text-xs tw:w-10 tw:text-right tw:opacity-50">36px</span>
          <ProgressBarPlay :progress="70" height="36px" class="tw:flex-1" />
        </div>
      </div>
    </section>

    <!-- PROP: showValue -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">showValue</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe a porcentagem centralizada sobre a barra. Funciona melhor com alturas maiores.</p>
      <div class="tw:max-w-lg tw:space-y-5">
        <ProgressBarPlay :progress="45" height="24px" :show-value="true" />
        <ProgressBarPlay :progress="78" height="24px" :show-value="true" />
        <ProgressBarPlay :progress="100" height="24px" :show-value="true" />
      </div>
    </section>

    <!-- Interativo -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Interativo</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Arraste o slider para ver a transição animada</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <ProgressBarPlay :progress="interactive" height="20px" :show-value="true" />
        <input v-model.number="interactive" type="range" min="0" max="100" class="tw:w-full" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { ProgressBarPlay } from '@/components/atomic'

const interactive = ref(60)
</script>
